module.exports = __webpack_public_path__ + "validation-error.svg?ec21178430a2cba3c701e23e227e79c5";